import { displayToast } from "../modules/utils";

export default class AccessPointSearch {
  constructor(node) {
    this.element = node;
    this.searchInputElement = this.element.querySelector(".js-ups-access-point-search");
    this.accessPointsWrapper = this.element.querySelector(".js-access-points-wrapper");

    this.url = new URL(this.element.dataset.url, window.location);
    this.timeout;

    this.initialize();
  }

  initialize() {
    this.search();

    this.searchInputElement.addEventListener("input", () => {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => this.search(), 500);
    });
  }

  search() {
    if (this.searchInputElement.value.length >= 4) {
      this.url.searchParams.set("query", this.searchInputElement.value);
      this.loadOptions();
    }
  }

  loadOptions() {
    this.accessPointsWrapper.classList.add("is-loading");

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        const { upsAccessPoints } = data;
        const accessPoints = Object.values(upsAccessPoints);

        this.accessPointsWrapper.innerHTML = "";

        accessPoints.forEach((accessPoint) => {
          const { id, pointName, streetName, postalCode, distance, distanceFormat } = accessPoint;
          const htmlElement = `
          <label class="custom-radio access-point d-flex align-items-start gap-3">
            <input type="radio" name="accessPoint" class="me-0 js-access-point-input" value=${id} />
            <div class="d-flex flex-column w-100">
              <span class="fw-semibold">${pointName}</span>
              <span>${streetName}</span>
              <span>${postalCode}</span>
            </div>
            <span class="distance">${distance} <span>${distanceFormat}</span></span>
          </label>`;

          this.accessPointsWrapper.insertAdjacentHTML("beforeend", htmlElement);
        });

        this.accessPointsWrapper.classList.remove("is-loading");
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        window.Appsignal.sendError(e);
      });
  }
}
